import React from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
export function EvaSchiffererProfilPage() {
  return <div className="min-h-screen bg-white" data-id="element-1755">
      <Header data-id="element-1756" />
      <main className="w-full pt-[152px]" data-id="element-1757">
        {/* Hero Section mit Bild */}
        <div className="w-full flex justify-center" data-id="element-1758">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-1759">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mk4Nnn5716nwRorptFdAAm/Header-Profil-Eva_Schifferer.jpg" alt="Eva Sophie Schifferer" className="w-full h-full object-cover object-[30%_center]" data-id="element-1760" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-1761"></div>
          </div>
        </div>
        {/* Willkommenstext */}
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-1762">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1763">
            Profil
          </h1>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-1764">
            <p data-id="element-1765">
              Als Diplom-Psychologin mit den Schwerpunkten klinische Psychologie
              und Wirtschaftspsychologie bringe ich rund 25 Jahre
              Berufserfahrung, u.a. in DAX-Konzernen mit - in Führungsrollen
              sowie als internationale Projektleiterin. Ich kenne die Dynamiken,
              Herausforderungen und Spannungsfelder, die sich an der
              Schnittstelle zwischen persönlichem Anspruch und beruflicher
              Realität zeigen.
            </p>
            <p data-id="element-1766">
              Parallel dazu arbeite ich als Coachin für Führungskräfte,
              Paartherapeutin und Psychotherapeutin (Staatliche Zulassung als
              Heilpraktikerin für Psychotherapie) mit einem systemischen und
              verhaltenstherapeutisch fundierten Ansatz. Ich unterstütze
              Menschen dabei, sich aus inneren oder zwischenmenschlichen
              Verstrickungen zu lösen, Klarheit zu gewinnen und neue
              Handlungsspielräume zu entdecken.
            </p>
            <p data-id="element-1767">
              Krisen sind kräftezehrend – müssen aber nicht dauerhaft sein.
              Gemeinsam entwickeln wir Strategien, die alltagstauglich, wirksam
              und individuell stimmig sind. Ziel ist es, den Weg in mehr
              Leichtigkeit, Stabilität und Sinn zu verkürzen – beruflich wie
              privat.
            </p>
          </div>
        </div>
        {/* Meine Motivation Section */}
        <div className="max-w-5xl mx-auto pb-16 px-6 md:px-12" data-id="element-1768">
          <div data-id="element-1769">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1770">
              Meine Motivation
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-1771">
              <p data-id="element-1772">
                Im Zuge meiner langjährigen Berufserfahrung in diversen Rollen
                u.a. als Executive Coachin, Beraterin, Führungskraft und last
                but not least als Mutter von zwei erwachsenen Kindern und
                Partnerin ist mir deutlich geworden: es sind letztlich immer die
                Beziehungen, die den Unterschied machen. Inklusive natürlich der
                Beziehung zu uns selbst.
              </p>
              <div className="flex flex-col md:flex-row gap-8 my-8" data-id="element-1773">
                <div className="md:w-1/2 text-lg text-gray-600" data-id="element-1774">
                  <p data-id="element-1775">
                    Ich weiß aus eigener Erfahrung, wie herausfordernd es sein
                    kann, im Alltag zwischen beruflichen Anforderungen,
                    familiären Bedürfnissen und eigenen Ansprüchen die Balance
                    zu halten. Diese Perspektive prägt meine Arbeit: empathisch
                    und gleichzeitig klar – mit einem realistischen Blick
                    darauf, was im echten Leben funktioniert.
                  </p>
                </div>
                <div className="md:w-1/2" data-id="element-1776">
                  <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1777">
                    <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1778">
                      "The quality of our relationships determines the quality
                      of our lives"
                    </blockquote>
                    <p className="text-right text-gray-600" data-id="element-1779">– Esther Perel</p>
                  </div>
                </div>
              </div>
              <p data-id="element-1780">
                Es motiviert mich, Menschen dabei zu begleiten, ihre wirklichen
                Stärken besser kennen zu lernen und Herausforderungen zu
                meistern – um damit ihr volles Potenzial im Alltag zu entfalten.
                Denn so entstehen neue Möglichkeiten: im Denken, Handeln und im
                Miteinander.
              </p>
              <p data-id="element-1781">
                Ich verbinde psychologisches Fachwissen mit langjähriger
                Berufserfahrung im Unternehmenskontext – und arbeite
                gleichermaßen menschlich zugewandt wie klar strukturiert. In
                meiner Praxis treffen systemische Denkweise,
                verhaltenstherapeutische Methoden und Coaching-Kompetenz auf
                einen wertschätzenden Blick für Ihre individuelle Situation.
              </p>
              <div className="flex flex-col md:flex-row gap-6" data-id="element-1782">
                <div className="md:w-1/2" data-id="element-1783">
                  <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white h-full flex flex-col justify-center" data-id="element-1784">
                    <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1785">
                      "Der Lösung ist es egal, wie das Problem entstanden ist."
                    </blockquote>
                    <p className="text-right text-gray-600" data-id="element-1786">
                      – Steve de Shazer
                    </p>
                  </div>
                </div>
                <div className="md:w-1/2" data-id="element-1787">
                  <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1788">
                    Was mich auszeichnet, ist meine Fähigkeit, auch in komplexen
                    oder belastenden Situationen Orientierung zu geben, Klarheit
                    zu schaffen und Entwicklung möglich zu machen – immer mit
                    Pragmatismus, Wertschätzung und einem Gespür für das
                    Wesentliche.
                  </p>
                </div>
              </div>
              <p data-id="element-1789">
                Mir ist wichtig, dass Beratung und Therapie verständlich,
                wirksam und alltagstauglich sind – ohne Umwege über Esoterik
                oder schnelle Patentrezepte. Stattdessen arbeite ich mit
                bewährten Methoden, einem geschulten diagnostischen Blick und
                dem Ziel, gemeinsam Lösungen zu entwickeln, die zu Ihnen und
                Ihrem Leben passen.
              </p>
              <p data-id="element-1790">
                Meine Kunden beschreiben mich als klar, kreativ & die Dinge auf
                den Punkt bringend – dabei immer herzlich, wertschätzend und
                Sicherheit-gebend.
              </p>
            </div>
          </div>
        </div>
        {/* Qualifikationen Section */}
        <div className="max-w-5xl mx-auto pb-16 px-6 md:px-12 bg-gray-50 py-16 rounded-lg" data-id="element-1791">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-1792">
            Qualifikationen
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1793">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1794">
              <ul className="space-y-5" data-id="element-1795">
                <li className="flex items-start" data-id="element-1796">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1797"></div>
                  <div data-id="element-1798">
                    <p className="text-gray-700 font-medium" data-id="element-1799">Studium</p>
                    <p className="text-gray-600" data-id="element-1800">
                      Klinische Psychologie an der Universität Heidelberg und an
                      der State University of New York at Stony Brook
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1801">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1802"></div>
                  <div data-id="element-1803">
                    <p className="text-gray-700 font-medium" data-id="element-1804">
                      Verhaltenstherapie
                    </p>
                    <p className="text-gray-600" data-id="element-1805">
                      Weiterbildung an der Gesellschaft für Ausbildung in
                      Psychotherapie, Frankfurt am Main
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1806">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1807"></div>
                  <div data-id="element-1808">
                    <p className="text-gray-700 font-medium" data-id="element-1809">
                      Systemische Beratung
                    </p>
                    <p className="text-gray-600" data-id="element-1810">
                      Weiterbildung am Institut für systemische Beratung,
                      Wiesloch
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1811">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1812"></div>
                  <div data-id="element-1813">
                    <p className="text-gray-700 font-medium" data-id="element-1814">
                      Systemischer Coach
                    </p>
                    <p className="text-gray-600" data-id="element-1815">
                      Zertifizierung an der European Business School (EBS)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1816">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1817"></div>
                  <div data-id="element-1818">
                    <p className="text-gray-700 font-medium" data-id="element-1819">
                      Mitglied im Berufsverband Deutscher Psychologinnen und
                      Psychologen e.v. (BDP)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1820">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1821"></div>
                  <div data-id="element-1822">
                    <p className="text-gray-700 font-medium" data-id="element-1823">
                      Mitglied im Verband freier Psychotherapeuten (VFP)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1824">
              <ul className="space-y-5" data-id="element-1825">
                <li className="flex items-start" data-id="element-1826">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1827"></div>
                  <div data-id="element-1828">
                    <p className="text-gray-700 font-medium" data-id="element-1829">MBA</p>
                    <p className="text-gray-600" data-id="element-1830">
                      Change Management an der Henley Business School
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1831">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1832"></div>
                  <div data-id="element-1833">
                    <p className="text-gray-700 font-medium" data-id="element-1834">Paartherapie</p>
                    <p className="text-gray-600" data-id="element-1835">
                      Weiterbildung nach John Gottman (Level 1 Training),
                      „Bridging the Couple Chasm - A new research based
                      approach"
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1836">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1837"></div>
                  <div data-id="element-1838">
                    <p className="text-gray-700 font-medium" data-id="element-1839">
                      Integrative Paartherapie
                    </p>
                    <p className="text-gray-600" data-id="element-1840">
                      Weiterbildung an der Norddeutschen Paarakademie Hamburg
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1841">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1842"></div>
                  <div data-id="element-1843">
                    <p className="text-gray-700 font-medium" data-id="element-1844">
                      Heilpraktikerin für Psychotherapie
                    </p>
                    <p className="text-gray-600" data-id="element-1845">Zulassung in Hessen</p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1846">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-1847"></div>
                  <div data-id="element-1848">
                    <p className="text-gray-700 font-medium" data-id="element-1849">
                      Ehrenamtliches Engagement beim Zonta Club Frankfurt -
                      Build a better world for women and girls
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Berufliche Stationen Section */}
        <div className="max-w-5xl mx-auto pb-24 px-6 md:px-12 pt-10" data-id="element-1850">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-1851">
            Berufliche Stationen
          </h2>
          <div data-id="element-1852">
            <ul className="space-y-3" data-id="element-1853">
              <li className="flex items-start" data-id="element-1854">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mr-3 mt-2" data-id="element-1855"></div>
                <p className="text-gray-600" data-id="element-1856">
                  Mitarbeiterin an der Psychiatrischen Universitätsklinik
                  Heidelberg in der Behandlung und Erforschung depressiver
                  Erkrankungen
                </p>
              </li>
              <li className="flex items-start" data-id="element-1857">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mr-3 mt-2" data-id="element-1858"></div>
                <p className="text-gray-600" data-id="element-1859">
                  Beraterin für Management Diagnostik und Talent Management
                  Volkswagen AG
                </p>
              </li>
              <li className="flex items-start" data-id="element-1860">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mr-3 mt-2" data-id="element-1861"></div>
                <p className="text-gray-600" data-id="element-1862">
                  HR-Managerin, T-Systems, Deutsche Telekom AG
                </p>
              </li>
              <li className="flex items-start" data-id="element-1863">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mr-3 mt-2" data-id="element-1864"></div>
                <p className="text-gray-600" data-id="element-1865">
                  Karriere-Coaching und Outplacement Beratung
                </p>
              </li>
              <li className="flex items-start" data-id="element-1866">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mr-3 mt-2" data-id="element-1867"></div>
                <p className="text-gray-600" data-id="element-1868">
                  <a href="https://www.wandelwert.com" target="_blank" rel="noopener noreferrer" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1869">
                    Geschäftsführerin als Executive Coachin
                  </a>{' '}
                  und Beraterin für Management Diagnostik, und Change Management
                </p>
              </li>
              <li className="flex items-start" data-id="element-1870">
                <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mr-3 mt-2" data-id="element-1871"></div>
                <p className="text-gray-600" data-id="element-1872">
                  Gründung der psychologischen Praxis für Paar- und
                  Einzelberatung
                </p>
              </li>
            </ul>
          </div>
        </div>
      </main>
      <EvaSchiffererFooter data-id="element-1873" />
    </div>;
}